import { createAsyncThunk } from '@reduxjs/toolkit';
import { FEATURE_VALUE, partition } from '@socialive/common';
import { getTreatments } from '@splitsoftware/splitio-redux';

const isDynamic = (feature) => feature.evalOnUpdate;
const getValue = (feature) => feature.value;
const featuresToSplitNames = (features) => features.map(getValue);

export default createAsyncThunk(
  'features/getTreatments',
  async ({ splitNames, key, attributes }, { dispatch, getState }) => {
    const features = splitNames.map((featureName) => FEATURE_VALUE[featureName]);
    const [dynamicSplitNames, staticSplitNames] = partition(features, isDynamic).map(featuresToSplitNames);

    if (dynamicSplitNames.length) {
      await dispatch(
        getTreatments({
          splitNames: dynamicSplitNames,
          key,
          evalOnUpdate: true,
          attributes,
        })
      );
    }

    if (staticSplitNames.length) {
      await dispatch(
        getTreatments({
          splitNames: staticSplitNames,
          key,
          evalOnUpdate: false,
          attributes,
        })
      );
    }

    return {
      dynamic: dynamicSplitNames,
      static: staticSplitNames,
    };
  }
);
